module.exports = __webpack_public_path__ + "media/img/kim-logo-54970acc8cfcc33243f92983e6592b67.jpg";